import { useState } from "react";
import "./ForgotPassword.css";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { returnToFromSearch } from '../utils/session';

function ForgotPassword() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setMessage("");

    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}password-reset/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email }),
      });

      if (response.ok) {
        const data = await response.json();
        setMessage(t("password_reset_email_sent"));
      } else {
        const errorData = await response.json();
        setError(errorData.detail || t("password_reset_failed"));
      }
    } catch (err) {
      setError(t("password_reset_error"));
    } finally {
      setLoading(false);
    }
  };

  const handleLoginRedirect = () => {
    const returnTo = returnToFromSearch(window.location.search);
    navigate(returnTo ? `/login?returnTo=${encodeURIComponent(returnTo)}` : '/login');
  };

  return (
    <div className="forgot-password-form-container">
      <form className="forgot-password-form" onSubmit={handleSubmit}>
        <h1 className="forgot-form-title">{t("forgot_password")}</h1>
        <div className="forgot-password-input">
          <input
            id="email"
            type="email"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder={t("email")}
            required
            autoComplete="email"
          />
        </div>
        <div className="submit-area">
          <button className="submit-forgot-password" type="submit" disabled={loading}>
            {t("send_reset_link")}
            {loading && <span className="forgot-password-loader"></span>}
          </button>
        </div>
        {message && <div className="forgot-password-message">{message}</div>}
        {error && <div className="forgot-password-error">{error}</div>}
        <div className="signup-row">
          <span>{t("forgot_remembered_password")}</span>
          <span className="forgot-signup-link" onClick={handleLoginRedirect}>{t("login") || "Login"}</span>
        </div>
      </form>
    </div>
  );
}

export default ForgotPassword;
